import { render, staticRenderFns } from "./NormalSearchNav229.vue?vue&type=template&id=054be3df&scoped=true&"
import script from "./NormalSearchNav229.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav229.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054be3df",
  null
  
)

export default component.exports